import { ITaskAttachmentsWrapper } from './ITaskAttachmentsWrapper'
import { Entity } from '@core/entities/entity'
import { plainToInstance, Type } from 'class-transformer'
import { TaskAttachment } from './TaskAttachment'

export class TaskAttachmentsWrapper extends Entity<ITaskAttachmentsWrapper> {
  @Type(() => TaskAttachment)
  data: Array<TaskAttachment>

  public static new(payload: unknown): TaskAttachmentsWrapper {
    const entity = plainToInstance<TaskAttachmentsWrapper, unknown>(
      TaskAttachmentsWrapper,
      payload,
    )

    return entity
  }
}
